import {
  getAllPersonas,
  checkPersonaReferencia,
  checkPersona,
  postPersona,
  putPersona,
} from "@/api/personas.api";

const state = {
  personas: [],
  antiguos: [],
  nuevos: [],
  formas: [],
  solicitante: null,
};

const getters = {
  /**
   * Return all personas
   *
   */

  getPersonas(state) {
    return state.personas;
  },

  /**
   * Return all nuevos
   *
   */

  getNuevos(state) {
    return state.nuevos;
  },

  /**
   * Return all antiguos
   *
   */

  getAntiguos(state) {
    return state.antiguos;
  },

  /**
   * Return solicitante
   *
   */

  getSolicitante(state) {
    return state.solicitante;
  },

  /**
   * Return all formas
   *
   */

  getFormas(state) {
    return state.formas;
  },

  /**
   * Return nuevos by DNI
   *
   */

  getNuevosByDni: (state) => (dni) => {
    return state.nuevos.filter(function(persona) {
      return persona.dni == dni;
    });
  },
};

const actions = {
  /**
   * Fetch personas from the API
   *
   */

  async fetchPersonas({ commit }) {
    try {
      const response = await getAllPersonas();

      commit("SET_PERSONAS", response.data);
    } catch (error) {
      // console.log('handle errors')
    }
  },

  /**
   * Set formas
   *
   */

  setFormas({ commit }, data) {
    commit("SET_FORMAS", data);
  },

  /**
   * Check persona
   *
   */

  setPersona({ commit }, data) {
    switch (data.antiguo) {
      case 1:
        commit("SET_PERSONA_NUEVO", data);

        break;

      case 2:
        commit("SET_PERSONA_ANTIGUO", data);

        break;

      default:
        commit("SET_PERSONA_SOLICITANTE", data);
    }
  },

  /**
   * Check persona by DNI
   *
   */

  async checkPersona({ dispatch, commit }, data) {
    let errorCode = "CODE13";

    try {
      const response = await checkPersona(data.dni);

      if (response.data.length > 0) {
        return response.data[0];
      } else {
        // If not solicitante
        if (data.componentId != 1678) {
          dispatch(
            "Errors/setError",
            { error: errorCode, componentId: data.componentId },
            { root: true }
          );
        }

        return false;
      }
    } catch (error) {
      // If not solicitante
      if (data.componentId != 1678) {
        dispatch(
          "Errors/setError",
          { error: errorCode, componentId: data.componentId },
          { root: true }
        );
      }

      return false;
    }
  },

  /**
   * Check persona by DNI
   *
   */

  async checkPersonaReferencia({ dispatch, commit }, data) {
    let errorCode = "CODE13";

    try {
      const response = await checkPersonaReferencia(data.codigo);

      if (response.data.id) {
        return response.data;
      } else {
        // If solicitante amigo
        if (data.componentId != 1678) {
          dispatch(
            "Errors/setError",
            { error: errorCode, componentId: data.componentId },
            { root: true }
          );
        }

        return false;
      }
    } catch (error) {
      // If solicitante amigo
      if (data.componentId != 1678) {
        dispatch(
          "Errors/setError",
          { error: errorCode, componentId: data.componentId },
          { root: true }
        );
      }

      return false;
    }
  },

  /**
   * Put persona
   *
   */

  async putPersona({ dispatch }, data) {
    try {
      const response = await putPersona(data.id, data.data);

      if (response) {
        return response;
      } else {
        return false;
      }
    } catch (error) {
      dispatch(
        "Errors/setError",
        { error: "CODE19", componentId: data.componentId },
        { root: true }
      );

      // console.log(error)

      return false;
    }
  },

  /**
   * Create persona
   *
   */

  async createPersona({ dispatch, commit }, data) {
    try {
      const response = await postPersona(data.data);

      if (response.statusText == "Created") {
        return response.data;
      } else {
        return false;
      }
    } catch (error) {
      dispatch(
        "Errors/setError",
        { error: "CODE12", componentId: data.componentId },
        { root: true }
      );

      return false;
    }
  },
};

const mutations = {
  /**
   * Add personas to the state
   *
   */

  SET_PERSONAS(state, data) {
    state.personas = data;
  },

  /**
   * Add persona to the state
   *
   */

  SET_PERSONA_NUEVO(state, data) {
    // Si existe

    let exist = state.nuevos.find((p) => p.id === data.id);

    if (typeof exist !== "undefined") {
      let index = state.nuevos.indexOf(exist);
      state.nuevos.splice(index, 1);
    }

    // Si existe el previo
    let existp = state.nuevos.find((p) => p.id === data.previousid);

    if (typeof existp !== "undefined") {
      let index = state.nuevos.indexOf(existp);
      state.nuevos.splice(index, 1);
    }

    state.nuevos.push(data);
  },

  /**
   * Add persona to the state
   *
   */

  SET_PERSONA_ANTIGUO(state, data) {
    let exist = state.antiguos.find((p) => p.id === data.id);

    if (typeof exist !== "undefined") {
      let index = state.antiguos.indexOf(exist);
      state.antiguos.splice(index, 1);
    }

    // Si existe el previo
    let existp = state.antiguos.find((p) => p.id === data.previousid);

    if (typeof existp !== "undefined") {
      let index = state.antiguos.indexOf(existp);
      state.antiguos.splice(index, 1);
    }

    state.antiguos.push(data);
  },

  /**
   * Add persona to the state
   *
   */

  SET_PERSONA_SOLICITANTE(state, data) {
    state.solicitante = data;
  },

  /**
   * Add formas
   *
   */

  SET_FORMAS(state, data) {
    state.formas = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
